import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=5405396e&scoped=true&"
import script from "./menus.vue?vue&type=script&lang=js&"
export * from "./menus.vue?vue&type=script&lang=js&"
import style0 from "./menus.vue?vue&type=style&index=0&id=5405396e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5405396e",
  null
  
)

export default component.exports